import { memo, useCallback, useEffect, useState } from "react";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";
import { DatePicker } from "ui/components/DatePicker";
import { ContractSaleStatusDropdown } from "ui/components/Dropdown/ContractSaleStatusDropdown";
import { VehicleContractSaleSearchFilterProps } from "./types";
import { useTranslate } from "helpers";
import { FleetVehicleContractSaleSearchFormValues } from "services/api/fleet/vehicles/contracts/types";
import { initialFleetVehicleContractSaleSearchForm } from "services/api/fleet/vehicles/contracts/consts";
import {
  useHandleTextFieldChange,
  useHandleDropdownChange,
  useHandleDateChange,
  useHandleNumberFieldChange,
} from "services/forms/hooks";

const VehicleContractSaleSearchFilters: React.FC<VehicleContractSaleSearchFilterProps> = (props) => {
  const { onAddNew, onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetVehicleContractSaleSearchFormValues>(
    initialFleetVehicleContractSaleSearchForm
  );
  useEffect(() => {
    onSearchChange(formValues);
  }, [formValues]);

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleNumberFieldChange = useHandleNumberFieldChange(setFormValues, formValues);

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleContractSaleSearchForm);
  }, []);

  return (
    <div className="flex flex-wrap items-end gap-2 mb-3">
      <div className="w-[150px]">
        <TextField
          type="text"
          name="search"
          value={formValues.search}
          onChange={handleTextFieldChange}
          placeholder="Pretraži..."
          startIcon="/media/icons/search.svg"
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[150px]">
        <ContractSaleStatusDropdown
          name="contractSaleStatusId"
          value={formValues.contractSaleStatusId}
          onChange={handleDropdownChange}
          placeholder="Status"
          width="full"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="contractDateFrom"
          label="Ugovor od - do"
          value={formValues.contractDateFrom}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="contractDateTo"
          value={formValues.contractDateTo}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="sellingPriceMin"
          label="Cijena od - do"
          placeholder="Cijena od"
          value={formValues.sellingPriceMin}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="sellingPriceMax"
          placeholder="do"
          value={formValues.sellingPriceMax}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <span
        onClick={handleResetFormClick}
        className="text-xs font-bold cursor-pointer text-gray-500 hover:text-sky-600 pb-2 whitespace-nowrap"
      >
        RESET
      </span>
      <div className="ml-auto">
        <Button
          variant="primary"
          children={t("admin.fleet.vehicle.contract.sale.search.add")}
          startIcon="/media/icons/plus.svg"
          onClick={onAddNew}
        />
      </div>
    </div>
  );
};
export default memo(VehicleContractSaleSearchFilters);
